import hpsf from '../sources/HermesPSF.js';
import config from '../config/';
import { SetStorageItem } from '../utilities/storageHelper';

// dispatch an action that sets the address that's displayed eg. in the search
// bar. Also get the position according to the address.
export const SET_ADDRESS = 'SET_ADDRESS';
export const setAddress = (address, alsoSetPosition = true, placesDetailsLAT, placesDetailsLNG) => dispatch => {
  dispatch({type: SET_ADDRESS, address});
  dispatch(hideMessage());

  if (alsoSetPosition) {
    return hpsf.addressToPosition(address, '', placesDetailsLAT, placesDetailsLNG)
      .then(position => dispatch(setPosition(position, false)))
      .catch(() => { dispatch(showMessage('error.address-resolve-failed')); })
    ;
  }
}

// dispatch an action to store the position and translate the position to
// an address, that will be displayed in the search bar
export const SET_POSITION = 'SET_POSITION';
export const setPosition = (position, alsoSetAddress = false) => dispatch => {
  dispatch({type: SET_POSITION, position});
  dispatch(hideMessage());

  if (alsoSetAddress) {
    return hpsf.positionToAddress(position)
      .then(address => dispatch(setAddress(address, false)))
      .catch(() => {
        dispatch(showMessage('error.position-resolve-failed'));
      })
    ;
  }
}

// this action retreives a single shop via its parcelShopNumber
export const GET_SHOP_BY_ID = 'FIND_SHOPS_BY_ID';

export const getShopById = (id, isDisabledCheck) => (dispatch, getState )=> {
  const state = getState(); // state has no "sortCode1" data => issue for showCallbackButton()

  if (typeof state.shops[id] === 'object') {
        //! MAKE AJAX CALL
        dispatch(receiveShop(state.shops[id], state.config.sortCode1, isDisabledCheck));

    return Promise.resolve();
  } else {
    return hpsf.getShopById(id)
      .then(result => {

        //! MAKE AJAX CALL
        dispatch(receiveShop(result.data, state.config.sortCode1, isDisabledCheck));
      })
      .catch()
    ;
  }
}

// action to notify the store that we're starting a new request
export const REQUEST_SHOP = 'REQUEST_SHOP';
export const requestShop = (id) => ({
  type: REQUEST_SHOP,
  id
});

// action to notify the store that we're starting a new request
export const REQUEST_SHOP_FAILED = 'REQUEST_SHOP_FAILED';
export const requestShopFailed = (id) => ({
  type: REQUEST_SHOP_FAILED,
  id
});

// an action to handle the finished request from above
export const RECEIVE_SHOP = 'RECEIVE_SHOP';
export const receiveShop = (result, sortCode1Data, isDisabledCheckData) => ({
  type: RECEIVE_SHOP,
  id: result.parcelShopNumber,
  result,
  sortCode1: sortCode1Data,
  isDisabled: isDisabledCheckData
});


// this action sets the address, gets the position and then requests the
// shops at that specific location
export const FIND_SHOPS_BY_ADDRESS = 'FIND_SHOPS_BY_ADDRESS';
export const getShopsAtAddress = (address, country, placesDetailsLAT, placesDetailsLNG) => dispatch => {
  dispatch(setAddress(address, false, placesDetailsLAT, placesDetailsLAT));
  dispatch(hideMessage());

  const isGoogleMapsInit = setInterval(() => {
    if (typeof google === 'object' && typeof google.maps === 'object' && typeof google.maps.Geocoder === 'function') {
      clearInterval(isGoogleMapsInit);
        return hpsf.addressToPosition(address, country, placesDetailsLAT, placesDetailsLNG)
        .then(position => {
            dispatch(setPosition(position));
            dispatch(getShopsAtPosition(position));
        })
        .catch(() => { dispatch(showMessage('error.address-resolve-failed')); });
    }
  }, 10); // runs until google.maps is init
}

// fetch shops with the current state
export const FETCH_SHOPS = 'FETCH_SHOPS';
export const fetchShops = () => (dispatch, getState) => {
  const state = getState();
  dispatch(hideMessage());
  dispatch(getShopsAtPosition(state.search.position));
};

// action to notify the store that we're starting a new request
export const REQUEST_SHOPS = 'REQUEST_SHOPS';
export const requestShops = () => ({
  type: REQUEST_SHOPS
});

export const REQUEST_SHOPS_FAILED = 'REQUEST_SHOPS_FAILED';
export const requestShopsFailed = response => ({
  type: REQUEST_SHOPS_FAILED,
  response
});

// an action to handle the finished request from above
export const RECEIVE_SHOPS = 'RECEIVE_SHOPS';
export const receiveShops = (result, doSetMapBounds=true) => dispatch => {
  if (result.length === 0) {
    dispatch(showMessage('error.no-shops'));
  } else {
    dispatch(hideMessage());
  }

  dispatch({
    type: RECEIVE_SHOPS,
    result,
    receivedAt: Date.now()
  });

  if (doSetMapBounds) {
    dispatch(setMapBounds());
  }
};

// first dispatch the action to request shops, then request the shops
// from the API at the current position, then dispatch the receive action.
export const getShopsAtPosition = (position, doSetMapBounds=true) => dispatch => {
  dispatch(requestShops());
  dispatch(hideMessage());

  return hpsf.getShopsAt(position)
    .then(result => {
      if (typeof result.data === 'object') {

        // Modifies response for application and google maps handling
        result.data.map(entry => {
            entry.lat = parseFloat(entry.latitude);
            entry.lng = parseFloat(entry.longitude);

            delete entry.latitude;
            delete entry.longitude;
        });

        dispatch(receiveShops(result.data, doSetMapBounds));
      } else {
        dispatch(requestShopsFailed(result.data));
        dispatch(showMessage('error.no-shops'));
      }
    })
    .catch((err) => {
      //dispatch(showMessage('error.no-shops'));
    });
};

// mark the current search result as invalid. eg. Address and/or position has
// changed and a new request would have to be made.
export const INVALIDATE_RESULT = 'INVALIDATE_RESULT';
export const invalidateResult = () => ({type: INVALIDATE_RESULT});

// hover over a shop. either in a list or in the map
export const HIGHLIGHT_SHOP = 'HIGHLIGHT_SHOP';
export const highlightShop = parcelShopNumber => ({ type: HIGHLIGHT_SHOP, parcelShopNumber });
// hover end
export const UNHIGHLIGHT_SHOP = 'UNHIGHLIGHT_SHOP';
export const unhighlightShop = () => ({ type: UNHIGHLIGHT_SHOP });

// click on a shop or its map link.
export const SELECT_SHOP = 'SELECT_SHOP';
export const selectShop = (parcelShopNumber, isDisabled) => dispatch => {
  dispatch({ type: SELECT_SHOP, parcelShopNumber });
  dispatch(getShopById(parcelShopNumber, isDisabled));
};


// deselect any previously selected shop
export const DESELECT_SHOP = 'DESELECT_SHOP';
export const deselectShop = () => ({ type:  DESELECT_SHOP });

export const SHOW_SHOP_DETAILS = 'SHOW_SHOP_DETAILS';
export const showShopDetails = parcelShopNumber => dispatch => {
  dispatch(getShopById(parcelShopNumber));
  dispatch({
    type: SHOW_SHOP_DETAILS,
    parcelShopNumber
  });
};

export const HIDE_SHOP_DETAILS = 'HIDE_SHOP_DETAILS';
export const hideShopDetails = () => ({ type: HIDE_SHOP_DETAILS });

// notify the store that a request for the users' position is progress
export const REQUEST_USER_POSITION = 'REQUEST_USER_POSITION';
export const requestUserPosition = () => {
  return {
    type: REQUEST_USER_POSITION
  };
};

// notify store that we now have the user position
export const RECEIVE_USER_POSITION = 'RECEIVE_USER_POSITION';
export const receiveUserPosition = position => {
  return {
    type: RECEIVE_USER_POSITION,
    position
  }
};

export const getShopsAtUserPosition = () => dispatch => {
  dispatch(requestUserPosition());
  dispatch(hideMessage());

  navigator.geolocation.getCurrentPosition((result) => {
    SetStorageItem('geo-location', 'allowed');

    const position = {
      lat: result.coords.latitude,
      lng: result.coords.longitude
    };

    dispatch(receiveUserPosition(position))
    dispatch(getShopsAtPosition(position));
    dispatch(setPosition(position, true)); // also set address
  }, (error) => {
    SetStorageItem('geo-location', 'failed');

    dispatch(failedUserPosition(error));
    dispatch(showMessage('error.user-geo-location-failed'));
  })
}

export const FAILED_USER_POSITION = 'FAILED_USER_POSITION';
export const failedUserPosition = error => {
  alert('Couldn\'t get user position: ' + error.message);

  return {
    type: FAILED_USER_POSITION,
    error
}
}

// action to set the callback button's url
export const SET_CALLBACK = 'SET_CALLBACK';
export const setCallback = (callbackUrl) => {
  // when set, displays a buttons and opens the cb_address and passes the
  // parameters: street, city, zip, name and parcelShopNumber:
  return {
    type: SET_CALLBACK,
    callbackUrl
  }
};

// action to set the language
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const setLanguage = (language) => {
  const isAllowed = config.allowedLanguages.indexOf(language) !== -1;

  if(!isAllowed) {
    console.error(`${language} is not in the list of allowed languages. Falling back to DE`); // eslint-disable-line
    language = 'de';
  }

  return {
    type: SET_LANGUAGE,
    language
  }
};

// action to set the country
export const SET_COUNTRY = 'SET_COUNTRY';
export const setCountry = (country) => {
  const isAllowed = config.allowedCountries.indexOf(country) !== -1;

  if(!isAllowed) {
    console.error(`${country} is not in the list of allowed countries. Falling back to DE`); // eslint-disable-line
    country = 'de';
  }

  return {
    type: SET_COUNTRY,
    country: country.toLowerCase()
  };
};

export const APPLY_FILTER = 'APPLY_FILTER';
export const applyFilter = filter => dispatch => {
  hpsf.setFilter(filter); // FIXME: find a nicer way to keep filter in sync

  dispatch(invalidateResult());
  dispatch({ type: APPLY_FILTER, filter });
}

export const REMOVE_FILTER = 'REMOVE_FILTER';
export const removeFilter = filter => dispatch => {
  hpsf.removeFilter(filter);

  dispatch(invalidateResult());
  dispatch({type: REMOVE_FILTER, filter});
};

// generic function to set config optinos
export const SET_OPTION = 'SET_OPTION';
export const setOption = (option, value) =>{
  return {
    type: SET_OPTION,
    option, value
  };
}

export const SHOW_SEARCH_DETAILS = 'SHOW_SEARCH_DETAILS';
export const showSearchDetails = () => ({type: SHOW_SEARCH_DETAILS});
export const HIDE_SEARCH_DETAILS = 'HIDE_SEARCH_DETAILS';
export const hideSearchDetails = () => ({type: HIDE_SEARCH_DETAILS});
export const TOGGLE_SEARCH_DETAILS = 'TOGGLE_SEARCH_DETAILS';
export const toggleSearchDetails = () => ({type: TOGGLE_SEARCH_DETAILS});

export const SHOW_MAP = 'SHOW_MAP';
export const showMap = () => dispatch => {
  dispatch({type: SHOW_MAP});
  dispatch(setMapBounds());
};

export const SHOW_LIST = 'SHOW_LIST';
export const showList = () => ({type: SHOW_LIST});

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const showMessage = message => {
  return {
    type: SHOW_MESSAGE,
    message
  }
};

export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const hideMessage = message => {
  return {
    type: HIDE_MESSAGE,
    message
  }
};

export const SET_MAP_CENTER = 'SET_MAP_CENTER';
export const setMapCenter = position => ({type: SET_MAP_CENTER, position});
export const SET_MAP_ZOOM = 'SET_MAP_ZOOM';
export const setMapZoom = zoom => ({type: SET_MAP_ZOOM, zoom});
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
export const setMapBounds = (dirty = true) => ({type: SET_MAP_BOUNDS, dirty});

